// src/supabase.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://pwtowrgrtkmkaqkjqhfd.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB3dG93cmdydGtta2Fxa2pxaGZkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTM2ODA2OTksImV4cCI6MjAyOTI1NjY5OX0.edZPhyITtMaKjiHNQWdhIBxKVI5l9X-Ucwts72ia0Ig'
export const supabase = createClient(supabaseUrl, supabaseKey)